(function () {
  'use strict';

  angular.module('wsLrs.directives').
  /**
   * This directive allows you to wrap an ng-click so we can safely pass it to $compile.  This isn't used often
   * but is needed initially in the metric report because of the dynamically created template.
   *
   * @param text The display value of the link
   * @param ws-ng-click The function call to be made
   */
  directive('wsSafeClick', [function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        text: '@',
        wsNgClick: '&'
      },
      template: "<a ng-click='wsNgClick()'>{{text}}</a>",
      link: function link(scope) {
        if (!scope.$parent.metricDisplayText) {
          delete scope.wsNgClick;
          throw "ws-safe-click directive only for use with metric display template currently";
        }

        // This is where we lock down specific usages of this.  While the ws-safe-click name
        // is not public or obvious, it's still a security hole should the name get out.  Here we
        // will check the context this directive is used in and only allow in specific cases.
        // Initially, this only exists to support the metric display openModal functionality;

        // These are the only functions that can be placed in our special ws-ng-click attribute
        var WHITELIST_FUNCTION_NAMES = ['openModal'];
        var isAllowed = false;
        _.forEach(WHITELIST_FUNCTION_NAMES, function (functionName) {
          if (scope.$parent.metricDisplayText.includes("ws-ng-click='" + functionName)) {
            isAllowed = true;
          }
        });
        if (!isAllowed) {
          delete scope.wsNgClick;
          throw "Function not allowed.  Must be explicitly declared safe";
        }
      }
    };
  }]);
})();
